import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';

import { FlexBox, FlexBoxColumn } from '@ecp/common/src/layouts/flex/styled';
import LabeledCheckBox from '@ecp/common/src/components/checkbox/bo/LabeledCheckBox';
import CheckboxGroupUnstyled from '@ecp/common/src/components/unstyled/checkbox/CheckboxGroupUnstyled';

const AllCheckboxGroup = ({ onChange, direction, itemList, checked, disabled, ...props }) => {
  const allItemList = useMemo(
    () => [
      {
        value: 'all',
        labelText: '전체',
        checked: itemList.every(({ value }) => checked.includes(value)),
        disabled: disabled || itemList.some(({ disabled }) => disabled),
      },
      ...itemList.map((item) => ({ ...item, checked: checked.includes(item.value) })),
    ],
    [checked, disabled, itemList]
  );

  const handleCheckboxChange = useCallback(
    (index, data, e) => {
      const items = [...allItemList];
      items[index] = data;
      if (index === 0) {
        items.map((item) => (item.checked = data.checked));
      } else {
        items[0] = { ...items[0], checked: items.slice(1).every(({ checked }) => checked) };
      }
      onChange?.(e, {
        valueType: 'array',
        value: items
          .slice(1)
          .filter(({ checked, disabled }) => checked && !disabled)
          .map(({ value }) => value),
      });
    },
    [allItemList, onChange]
  );

  const rootComponent = direction === 'row' ? FlexBox : FlexBoxColumn;
  return (
    <CheckboxGroupUnstyled
      disabled={disabled}
      rootComponent={rootComponent}
      onChange={handleCheckboxChange}
      itemList={allItemList}
      flex-shrink={'0'}
      {...props}
    />
  );
};

export default AllCheckboxGroup;

AllCheckboxGroup.propTypes = {
  rootComponent: PropTypes.oneOfType([PropTypes.elementType, PropTypes.element]),
  itemComponent: PropTypes.oneOfType([PropTypes.elementType, PropTypes.element]),
  itemList: PropTypes.array.isRequired,
  rootProps: PropTypes.object,
  itemProps: PropTypes.object,
  checked: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.bool])),
  onChange: PropTypes.func,
  direction: PropTypes.oneOf(['row', 'column']),
  disabled: PropTypes.bool,
};

export const allCheckboxRootStyle = { gap: '6px 14px', 'align-items': 'flex-start', 'flex-wrap': 'wrap' };

AllCheckboxGroup.defaultProps = {
  direction: 'row',
  itemComponent: LabeledCheckBox,
  itemList: [],
  rootProps: allCheckboxRootStyle,
  itemProps: {},
  checked: [],
};
